import type { SPACE_DATA, SPACE_PARAMS } from './types'

import { DEFAULT_MARGIN, DEFAULT_PADDING, DEFAULT_WIDTH } from '../const'

const DEFAULT_SPACE_PARAMS_DEVICE = () => ({
  hidden: false,
  width: DEFAULT_WIDTH(),
  height: { value: 1, unit: 'px' },
  padding: DEFAULT_PADDING(),
  margin: DEFAULT_MARGIN(),
})

export const DEFAULT_SPACE_PARAMS = (): SPACE_PARAMS => ({
  pc: DEFAULT_SPACE_PARAMS_DEVICE(),
  tablet: DEFAULT_SPACE_PARAMS_DEVICE(),
  mobile: DEFAULT_SPACE_PARAMS_DEVICE(),
})

export const DEFAULT_SPACE_DATA = (): SPACE_DATA => ({
  id: null,
  classes: null,
  styles: null,
  type: 'space',
})
